<template>
    <v-container fluid class="pa-1" :style="$vuetify.display.mobile ? 'width: 100vw;' : ''">
        <template v-if="!$vuetify.display.mobile">
            <v-row no-gutters>
                <v-col cols="7" class="pr-1">
                    <v-card class="default_card_wm elevation-0 pt-2">
                        <DocumentMenu
                            :MenuOptions="documentMenuOptions"
                            @zoom-in="zoomManager.zoomIn()"
                            @reset-zoom="zoomManager.resetZoom()"
                            @zoom-out="zoomManager.zoomOut()"
                            @rotate-left="
                                documentPdfRotation = rotate(
                                    'left',
                                    zoomManager,
                                    documentPdfRotation,
                                )
                            "
                            @rotate-right="
                                documentPdfRotation = rotate(
                                    'right',
                                    zoomManager,
                                    documentPdfRotation,
                                )
                            "
                            @download="startDownloadFile()"
                            @delete="deleteDocumentDialog = true"
                        ></DocumentMenu>
                        <v-row no-gutters>
                            <!--
                            <v-col cols="6">
                                <v-btn-back
                                    @click.stop="back()"
                                    v-if="mode !== 'GeneralLedger' && goBackHistory"
                                    data-cy="document-back"
                                />
                                <v-btn-icon
                                    icon="$oss-zoom-out"
                                    :disabled="zoomManager.disableZoomOut()"
                                    class="btn mr-1"
                                    @click.stop="zoomManager.zoomOut()"
                                    v-if="showZoomActions"
                                />
                                <v-btn-icon
                                    icon="$oss-focus"
                                    :disabled="zoomManager.disableResetZoom()"
                                    class="btn mx-1"
                                    @click.stop="zoomManager.resetZoom()"
                                    v-if="showZoomActions"
                                />
                                <v-btn-icon
                                    icon="$oss-zoom-in"
                                    :disabled="zoomManager.disableZoomIn()"
                                    class="btn ml-1"
                                    @click.stop="zoomManager.zoomIn()"
                                    v-if="showZoomActions"
                                />
                            </v-col>
                            <v-col cols="6" class="d-flex justify-end">
                                <v-btn-icon
                                    icon="$oss-download"
                                    class="mx-1"
                                    @click="startDownloadFile"
                                />
                                <v-menu offset-y>
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon
                                            icon="$dots_vertical"
                                            v-bind="props"
                                            class="mx-1"
                                        />
                                    </template>
                                    <v-list nav rounded="xl">
                                        <v-list-item
                                            @click="deleteDocumentDialog = true"
                                            :disabled="disabledDelete"
                                            color="error"
                                            :active="!disabledDelete"
                                        >
                                            <v-list-item-title>Supprimer</v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small">$oss-trash</v-icon>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                            -->
                            <!-- <v-col cols="6" class="d-flex justify-end" v-else>
                            <v-btn
                                @click="showAccountingLines = false"
                                icon
                                class="mx-1"
                                color="primary"
                            >
                                <v-icon  size="small">$oss-close</v-icon>
                            </v-btn>
                        </v-col> -->

                            <v-col
                                cols="12"
                                class="d-flex justify-center"
                                v-if="isPDF"
                                style="height: calc(100vh - 130px); overflow-y: auto"
                            >
                                <ossPdf :documentId="document.id" /> </v-col
                            ><v-col
                                cols="12"
                                style="height: calc(100vh - 130px); overflow-y: auto"
                                v-else
                            >
                                <div
                                    style="
                                        position: relative;
                                        width: 100%;
                                        height: 0;
                                        padding: 0;
                                        padding-bottom: 141.4516129032258%;
                                        margin-bottom: 50px;
                                    "
                                >
                                    <svg
                                        id="svg-document-to-reupload"
                                        v-if="document"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="100%"
                                        :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                        style="
                                            position: absolute;
                                            width: 100%;
                                            left: 0;
                                            top: 0;
                                            background: #fff;
                                        "
                                    >
                                        <g>
                                            <image
                                                id="svg-image-document-to-reupload"
                                                :xlink:href="document.signedUrl"
                                                x="0"
                                                y="0"
                                                :height="`${imageHeight}px`"
                                                :width="`${imageWidth}px`"
                                            />
                                            <template
                                                v-for="(variant, index) in svgVariants"
                                                :key="`coord-${document.id}-${index}`"
                                            >
                                                <template
                                                    v-for="(coord, index2) in variant.coordinates"
                                                    :key="`coord-${document.id}-${index}-${index2}`"
                                                >
                                                    <polygon
                                                        :ref="`variants-${index}-${index2}`"
                                                        :points="getPoints(coord)"
                                                        :style="
                                                            variant.active
                                                                ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                        "
                                                        @click.stop="
                                                            variant.active
                                                                ? ''
                                                                : showCorrespondingField({
                                                                      variant,
                                                                      currentIndex: index,
                                                                      copyIndex: index2,
                                                                  })
                                                        "
                                                        :class="variant.focus ? 'highlighted' : ''"
                                                    />
                                                </template>
                                            </template>
                                        </g>
                                    </svg>
                                </div> </v-col
                        ></v-row>
                    </v-card>
                    <v-list v-if="associatedFields.show" :style="svgPosition">
                        <v-list-item
                            v-for="(field, key, index) in associatedFields.fields"
                            :key="`field-${document.id}-${key}-${index}`"
                            @click="onFieldAssociation(field, key)"
                            class="oss-list-item"
                        >
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="5" class="my-0 pl-1">
                    <v-card
                        style="
                            border-top-right-radius: 0px !important;
                            border-bottom-right-radius: 0px !important;
                            height: calc(100vh - 82px);
                            overflow-y: auto;
                        "
                        class="default_card_wm elevation-0 rounded-l-0"
                    >
                        <v-window v-model="windowStep" touchless>
                            <v-window-item :step="0">
                                <!-- <v-card-title>
                                <v-row no-gutters>
                                    <v-col cols="12" class="headline">
                                        Détails du document
                                    </v-col>
                                </v-row>
                            </v-card-title> -->
                                <v-card-text class="pt-0">
                                    <v-form ref="form" v-model="valid">
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-list
                                                    single-line
                                                    class="pt-2 pb-0"
                                                    density="compact"
                                                >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="mb-2"
                                                        color="success"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                    "
                                                                >
                                                                    <b>Statut</b>
                                                                </v-col>
                                                                <v-col
                                                                    cols="9"
                                                                    class="pl-2 d-flex justify-space-between align-center"
                                                                >
                                                                    {{ documentStatus }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                    <v-list-item
                                                        clmass="oss-list-item"
                                                        :ripple="false"
                                                        class="mb-2"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                    "
                                                                >
                                                                    <b>{{ thirdPartyType() }}</b>
                                                                </v-col>
                                                                <v-col cols="9" class="pl-2">
                                                                    <div>
                                                                        {{
                                                                            document.thirdPartyCompany
                                                                                ? document
                                                                                      .thirdPartyCompany
                                                                                      .name
                                                                                : ""
                                                                        }}
                                                                    </div>
                                                                    <div class="body-2 pt-1">
                                                                        Siret :
                                                                        {{
                                                                            document.thirdPartyCompany &&
                                                                            document
                                                                                .thirdPartyCompany
                                                                                .siret
                                                                                ? getSiretValue(
                                                                                      document
                                                                                          .thirdPartyCompany
                                                                                          .siret,
                                                                                  )
                                                                                : ""
                                                                        }}
                                                                    </div>
                                                                    <div class="body-2">
                                                                        Adresse :
                                                                        {{ fullAddress }}
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                </v-list>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-list single-line class="py-0" density="compact">
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="oss-list-item my-2"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    class="d-flex align-center"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>Type</b>
                                                                </v-col>
                                                                <v-col cols="9" class="pl-2">
                                                                    {{
                                                                        formatCategory(
                                                                            document.type,
                                                                        )
                                                                    }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="my-2"
                                                        v-if="document.createdAt"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    class="d-flex align-center"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>Importer le </b>
                                                                </v-col>
                                                                <v-col cols="9" class="pl-2">
                                                                    {{
                                                                        formatDate(
                                                                            document.createdAt,
                                                                        )
                                                                    }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="my-2"
                                                        v-if="dueDateEnable"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    class="d-flex align-center"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>{{
                                                                        $t("shared.dueDate")
                                                                    }}</b>
                                                                </v-col>
                                                                <v-col cols="9" class="pl-2">
                                                                    <oss-date-picker-filled
                                                                        :model-value="dueDate"
                                                                        @change-date="
                                                                            onDueDateChanged
                                                                        "
                                                                        :textFieldReadOnly="false"
                                                                        :hideDetails="true"
                                                                    />
                                                                </v-col>
                                                            </v-row> </v-list-item-title
                                                    ></v-list-item>
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="my-2"
                                                        v-if="document.vatType"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    class="d-flex align-center"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>Type de TVA</b>
                                                                </v-col>
                                                                <v-col cols="9" class="pl-2">
                                                                    {{
                                                                        $t(
                                                                            `document.vatType.${document.vatType}`,
                                                                        )
                                                                    }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                </v-list>
                                            </v-col>
                                            <!-- <v-col cols="12">
                                            <h3 class="text-left">Type : {{ formatCategory(document.type) }}</h3>
                                        </v-col>
                                        <v-col cols="12">
                                            <h3 class="text-left">Avoir : {{ document.creditNote ? 'Oui': 'Non' }}</h3>
                                        </v-col>
                                        <v-col cols="12">
                                            <h3
                                                v-if="document.vatType"
                                                class="text-left"
                                            >Type de TVA : {{ $t(`document.vatType.${document.vatType}`) }}</h3>
                                        </v-col>
                                        <v-col cols="12" v-if="document.date">Date : {{ formatDate(document.date) }}</v-col>-->
                                            <!-- <v-col cols="12" v-if="dueDateEnable">
                                            <oss-date-picker
                                                :label="$t('shared.dueDate')"
                                                :date="dueDate"
                                                @change-date="onDueDateChanged"
                                            ></oss-date-picker>
                                        </v-col> -->
                                            <!-- <v-col cols="12">
                                            <v-row no-gutters class="py-2 align-center">
                                                <v-col class="col-auto pr-3">
                                                    Détails
                                                </v-col>
                                                <v-col >
                                                    <v-divider></v-divider>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" class="px-16">
                                            <v-data-table
                                                :headers="headers"
                                                :items="prices"
                                                class="table"
                                                fixed-header
                                                max-height="60vh"
                                                hide-default-footer
                                                style="border: 1px #EDEDED solid;"
                                            >
                                                <template v-slot:item="{ item }">
                                                    <tr>
                                                        <td
                                                            :class="item.total ? 'text-center font-weight-bold':'text-center font-weight-regular'"
                                                            v-if="multiAccountableAccount"
                                                        >
                                                            {{ item.accountableAccount !== null ? item.accountableAccount: '-' }}
                                                        </td>
                                                        <td
                                                            :class="item.total ? 'text-center font-weight-bold':'text-center font-weight-regular'"
                                                        >
                                                            {{ item.netAmountSigned !== null ? newCommonFormatCurrency(item.netAmountSigned, undefined): '-' }}
                                                        </td>
                                                        <td
                                                            :class="item.total ? 'text-center font-weight-bold':'text-center font-weight-regular'"
                                                        >
                                                            {{ item.vatRate !== null ? item.vatRate + '%' : '-' }}
                                                        </td>
                                                         <td
                                                            :class="item.total ? 'text-center font-weight-bold':'text-center font-weight-regular'"
                                                        >
                                                            {{ item.vatAmountSigned !== null ? newCommonFormatCurrency(item.vatAmountSigned, undefined): '-' }}
                                                        </td>
                                                        <td
                                                            :class="item.total ? 'text-center font-weight-bold':'text-center font-weight-regular'"
                                                        >
                                                            {{ item.grossAmountSigned !== null ? newCommonFormatCurrency(item.grossAmountSigned, undefined): '-' }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-col> -->
                                            <v-col cols="12">
                                                <upload-documents
                                                    :showFirstPrevious="false"
                                                    :showBtns="true"
                                                    :companyId="companyId"
                                                    :documentId="documentId"
                                                    :multiple="false"
                                                    :freeTag="false"
                                                    :hideTitle="true"
                                                    @fileUploaded="reuploaded()"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-btn
                                                    v-if="
                                                        document.type === 'PURCHASE_INVOICE' ||
                                                        document.type === 'SALES_INVOICE' ||
                                                        document.type === 'EXPENSE_REPORT_DOCUMENT'
                                                    "
                                                    elevation="0"
                                                    rounded
                                                    @click="switchToDocumentValidation()"
                                                    size="small"
                                                >
                                                    Passer à la validation
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card-text>
                            </v-window-item>
                            <!-- <v-window-item :step="1">
                                <v-card-title>
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="1">
                                            <v-btn-icon
                                                icon
                                                @click="closeMultiAccountableAccountWindow()"
                                                :loading="subNetAmountsLoading"
                                            />
                                        </v-col>
                                        <v-col cols="11" class="headline pl-2">
                                            Selection de plusieurs comptes comptable
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-subtitle>
                                    Montant total HT:
                                    {{ newCommonFormatCurrency(netAmountSigned, undefined) }}
                                </v-card-subtitle>
                                <v-card-text>
                                    <DocumentAccountableAccountsSelector
                                        v-model="subNetAmounts"
                                        :netAmount="netAmountSigned"
                                        :companyId="companyId"
                                        @modified="onSubAccountableAccountModified"
                                        @cancel="closeMultiAccountableAccountWindow"
                                    />
                                </v-card-text>
                            </v-window-item> -->
                        </v-window>
                        <v-card-actions
                            class="d-flex justify-center"
                            v-if="mode != 'GeneralLedger'"
                        >
                            <v-btn-prev :disabled="previousDisabled()" @click="previous()" />
                            <v-btn-next :disabled="nextDisabled()" @click="next()" />
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <oss-dialog
                v-model="dialogChooseDownload"
                title="Télécharger le document"
                width="800px"
            >
                Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

                <template v-slot:actions>
                    <v-row no-gutters>
                        <v-col cols="6" class="pr-2">
                            <v-btn-primary
                                rounded
                                block
                                @click="
                                    dialogChooseDownload = false;
                                    downloadFile(true);
                                "
                                size="x-large"
                                >Original</v-btn-primary
                            >
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <v-btn-primary
                                rounded
                                block
                                @click="
                                    dialogChooseDownload = false;
                                    downloadFile(false);
                                "
                                size="x-large"
                                >Marqué</v-btn-primary
                            >
                        </v-col>
                    </v-row>
                </template>
            </oss-dialog>
            <oss-dialog
                v-model="deleteDocumentDialog"
                title="Supprimer le document"
                :error="true"
                @valid="deleteDocument"
                :validTitle="'Oui je suis sûr(e)'"
                :validLoading="deleteDocumentLoading"
                width="800px"
            >
                <h4 class="text-center">
                    &#xca;tes-vous sûr(e) de vouloir supprimer le document ?
                </h4>
            </oss-dialog>
            <oss-dialog
                v-model="editDialog"
                title="Editer le document"
                @valid="editDocument"
                :validTitle="'Oui je suis sûr(e)'"
                :validLoading="editLoading"
                width="800px"
            >
                <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir éditer le document ?</h4>
            </oss-dialog>
            <Chat
                v-if="openChat"
                v-bind:id="document.chat ? document.chat.id : ''"
                v-bind:status="'INFORMATION_REQUEST'"
            />
        </template>
        <!-- Smartphone -->
        <template v-else>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-switch
                        v-model="showDocument"
                        hide-details
                        label="Afficher le document"
                        class="my-0 py-0"
                    />
                </v-col>
                <v-col cols="12">
                    <v-window v-model="step" class="fill-height">
                        <v-window-item :value="0">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-form ref="form" v-model="valid">
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-list
                                                    single-line
                                                    class="py-0"
                                                    style="background: transparent"
                                                    density="compact"
                                                >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="mb-2 px-1"
                                                        color="success"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    style="
                                                                        border-right: solid
                                                                            rgba(0, 0, 0, 0.12) 1px;
                                                                    "
                                                                >
                                                                    <b>Statut</b>
                                                                </v-col>
                                                                <v-col cols="9" class="pl-2">
                                                                    {{ documentStatus }}
                                                                    <v-spacer />
                                                                    <v-btn
                                                                        rounded
                                                                        elevation="0"
                                                                        v-if="
                                                                            reconciliationCallToAction
                                                                        "
                                                                        :disabled="
                                                                            disabledCallToAction
                                                                        "
                                                                        @click="
                                                                            openReconciliation()
                                                                        "
                                                                        size="x-small"
                                                                        >{{
                                                                            reconciliationCallToAction
                                                                        }}</v-btn
                                                                    >
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="oss-list-item mb-2 px-1"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="3"
                                                                    style="
                                                                        border-right: solid
                                                                            rgba(0, 0, 0, 0.12) 1px;
                                                                    "
                                                                >
                                                                    <b>{{ thirdPartyType() }}</b>
                                                                </v-col>
                                                                <v-col cols="9" class="pl-2">
                                                                    <div>
                                                                        {{
                                                                            document.thirdPartyCompany
                                                                                ? document
                                                                                      .thirdPartyCompany
                                                                                      .name
                                                                                : ""
                                                                        }}
                                                                    </div>
                                                                    <div class="body-2 pt-1">
                                                                        Siret :
                                                                        {{
                                                                            document.thirdPartyCompany &&
                                                                            document
                                                                                .thirdPartyCompany
                                                                                .siret
                                                                                ? getSiretValue(
                                                                                      document
                                                                                          .thirdPartyCompany
                                                                                          .siret,
                                                                                  )
                                                                                : ""
                                                                        }}
                                                                    </div>
                                                                    <div class="body-2">
                                                                        Adresse :
                                                                        {{ fullAddress }}
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="mb-2 px-1"
                                                        v-if="
                                                            activateTagguing &&
                                                            document.type !==
                                                                'EXPENSE_REPORT_DOCUMENT'
                                                        "
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <FreeTag
                                                                        v-bind:companyTags="
                                                                            allCompanyTags
                                                                        "
                                                                        v-bind:document="inDocument"
                                                                        @changed="
                                                                            startToBeDoneIfNecessary
                                                                        "
                                                                    />
                                                                </v-col>
                                                            </v-row> </v-list-item-title
                                                    ></v-list-item>
                                                </v-list>
                                            </v-col>
                                            <!-- <v-col cols="12">
                                            <v-card
                                                class="default_card_wm"
                                                style="background: #FFF !important; border: solid rgba(0, 0, 0, 0.12) 1px; box-shadow: none;"
                                                v-if="document.type !== 'WITHOUT_INVOICE' && document.type !== 'WITH_DELTA' && document.type !== 'BANK_CHARGE'"
                                            >
                                                <v-card-title primary-title>
                                                    {{ thirdPartyType() + (document.thirdPartyCompany ? document.thirdPartyCompany.name:"") }}
                                                </v-card-title>
                                                <v-card-text
                                                    v-if="document.thirdPartyCompany && document.thirdPartyCompany.type ==='NORMAL'"
                                                >
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            Siret : {{ document.thirdPartyCompany && document.thirdPartyCompany.siret ? document.thirdPartyCompany.siret : "" }}
                                                        </v-col>
                                                        <v-col cols="12">
                                                            Adresse : {{ document.thirdPartyCompany && document.thirdPartyCompany.address }}
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col> -->
                                            <!-- <v-col cols="12" v-if="activateTagguing && document.type!=='EXPENSE_REPORT_DOCUMENT'">
                                            <FreeTag v-bind:companyTags="allCompanyTags" v-bind:document="inDocument"></FreeTag>
                                        </v-col> -->
                                            <v-col
                                                cols="12"
                                                v-if="
                                                    isAccountingUser &&
                                                    currentUser.profile.configuration.accounting
                                                        .write &&
                                                    currentUser.profile.configuration.document.write
                                                "
                                            >
                                                <template v-if="subNetAmounts.length <= 1">
                                                    <v-row
                                                        no-gutters
                                                        class="pt-2 flex-grow-1 flex-shrink-0"
                                                        v-if="
                                                            !multiVat &&
                                                            document.type !== 'BANK_CHARGE' &&
                                                            document.type !== 'WITHOUT_INVOICE'
                                                        "
                                                    >
                                                        <v-col>
                                                            <AccountableAccountVue
                                                                :companyId="companyId"
                                                                :document="document"
                                                                :inputStyle="'padding: 0px; margin: 0px;'"
                                                                :showSuggestion="false"
                                                                :showDescription="true"
                                                                :showValidation="false"
                                                                :mandatory="false"
                                                                :hideDetails="true"
                                                                @close="closeAccountableAccount"
                                                                @select-accountableAccount="
                                                                    selectAccountableAccount
                                                                "
                                                            />
                                                        </v-col>
                                                        <!-- <v-col
                                                            class="flex-shrink-1 justify-end flex-grow-0 pt-1 pl-1"
                                                            v-if="document.type !== 'SALES_INVOICE'"
                                                        >
                                                            <v-btn
                                                                color="primary"
                                                                @click="activateSubNetAmountsStep()"
                                                                elevation="0"
                                                                size="x-small"
                                                                dark
                                                                fab
                                                                icon="$add"
                                                            >
                                                            </v-btn>
                                                        </v-col> -->
                                                    </v-row>
                                                </template>
                                                <template v-else>
                                                    <v-card
                                                        class="default_card_wm mx-auto"
                                                        style="
                                                            background: #fff !important;
                                                            box-shadow: none;
                                                        "
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="1Z">
                                                                <v-chip-group>
                                                                    <v-chip
                                                                        label
                                                                        v-for="(
                                                                            item, index
                                                                        ) in subNetAmounts"
                                                                        :key="index"
                                                                        size="small"
                                                                        variant="outlined"
                                                                    >
                                                                        {{
                                                                            item.accountableAccount
                                                                                .name
                                                                        }}
                                                                        ({{
                                                                            newCommonFormatCurrency(
                                                                                item.netAmountSigned,
                                                                                undefined,
                                                                            )
                                                                        }})
                                                                    </v-chip>
                                                                </v-chip-group>
                                                            </v-col>
                                                            <!-- <v-col
                                                                cols="1"
                                                                class="d-flex justify-end pt-2"
                                                            >
                                                                <v-btn
                                                                    color="primary"
                                                                    @click="
                                                                        activateSubNetAmountsStep()
                                                                    "
                                                                    elevation="0"
                                                                    dense
                                                                    size="x-small"
                                                                    fab
                                                                    icon="$edit"
                                                                >
                                                                </v-btn>
                                                            </v-col> -->
                                                        </v-row>
                                                    </v-card>
                                                </template>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-list
                                                    single-line
                                                    style="background: transparent"
                                                    class="py-0"
                                                    density="compact"
                                                >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="oss-list-item mb-2 px-1"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="4"
                                                                    style="
                                                                        border-right: solid
                                                                            rgba(0, 0, 0, 0.12) 1px;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>Type</b>
                                                                </v-col>
                                                                <v-col cols="8" class="pl-2">
                                                                    {{
                                                                        formatCategory(
                                                                            document.type,
                                                                        )
                                                                    }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="mb-2 px-1"
                                                        v-if="document.date"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="4"
                                                                    style="
                                                                        border-right: solid
                                                                            rgba(0, 0, 0, 0.12) 1px;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>Date</b>
                                                                </v-col>
                                                                <v-col cols="8" class="pl-2">
                                                                    {{ formatDate(document.date) }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="mb-2 px-1"
                                                        v-if="dueDateEnable"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="4"
                                                                    style="
                                                                        border-right: solid
                                                                            rgba(0, 0, 0, 0.12) 1px;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>{{
                                                                        $t("shared.dueDate")
                                                                    }}</b>
                                                                </v-col>
                                                                <v-col cols="8" class="pl-2">
                                                                    <!-- {{ formatDate(document.date) }} -->
                                                                    <oss-date-picker-filled
                                                                        :model-value="dueDate"
                                                                        @change-date="
                                                                            onDueDateChanged
                                                                        "
                                                                        :textFieldReadOnly="false"
                                                                        :hideDetails="true"
                                                                    />
                                                                </v-col>
                                                            </v-row> </v-list-item-title
                                                    ></v-list-item>
                                                    <v-list-item
                                                        :ripple="false"
                                                        class="mb-2 px-1"
                                                        v-if="document.vatType"
                                                    >
                                                        <v-list-item-title class="body-1">
                                                            <v-row no-gutters class="align-center">
                                                                <v-col
                                                                    cols="4"
                                                                    style="
                                                                        border-right: solid
                                                                            rgba(0, 0, 0, 0.12) 1px;
                                                                        height: 28px;
                                                                    "
                                                                >
                                                                    <b>Type de TVA</b>
                                                                </v-col>
                                                                <v-col cols="8" class="pl-2">
                                                                    {{
                                                                        $t(
                                                                            `document.vatType.${document.vatType}`,
                                                                        )
                                                                    }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-title></v-list-item
                                                    >
                                                </v-list>
                                            </v-col>
                                            <!-- <v-col cols="12" v-if="dueDateEnable">
                                            <oss-date-picker
                                                :label="$t('shared.dueDate')"
                                                :date="dueDate"
                                                @change-date="onDueDateChanged"
                                            ></oss-date-picker>
                                        </v-col> -->
                                            <v-col cols="12">
                                                <v-row no-gutters class="align-center py-2">
                                                    <v-col class="col-auto pr-3"> Détails </v-col>
                                                    <v-col>
                                                        <v-divider />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-data-table
                                                    :headers="headers"
                                                    :items="prices"
                                                    hide-default-footer
                                                    hide-default-header
                                                    class="table"
                                                    style="border: 1px #ededed solid"
                                                >
                                                    <template v-slot:header>
                                                        <tr>
                                                            <td
                                                                v-for="(header, index) in headers"
                                                                :key="index"
                                                                class="text-center py-2"
                                                            >
                                                                {{ header.text }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        <tr>
                                                            <td
                                                                :class="
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                "
                                                            >
                                                                {{
                                                                    item.accountableAccount !== null
                                                                        ? item.accountableAccount
                                                                        : "-"
                                                                }}
                                                            </td>
                                                            <td
                                                                :class="
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                "
                                                            >
                                                                {{
                                                                    item.netAmountSigned !== null
                                                                        ? newCommonFormatCurrency(
                                                                              item.netAmountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"
                                                                }}
                                                            </td>
                                                            <td
                                                                :class="
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                "
                                                            >
                                                                {{
                                                                    item.vatRate !== null
                                                                        ? item.vatRate + "%"
                                                                        : "-"
                                                                }}
                                                            </td>
                                                            <td
                                                                :class="
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                "
                                                            >
                                                                {{
                                                                    item.vatAmountSigned !== null
                                                                        ? newCommonFormatCurrency(
                                                                              item.vatAmountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"
                                                                }}
                                                            </td>
                                                            <td
                                                                :class="
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                "
                                                            >
                                                                {{
                                                                    item.grossAmountSigned !== null
                                                                        ? newCommonFormatCurrency(
                                                                              item.grossAmountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-flex>
                            </v-layout>
                        </v-window-item>
                        <v-window-item :value="1">
                            <v-row no-gutters>
                                <v-col cols="12" style="max-height: 85vh; overflow-y: auto">
                                    <div
                                        style="
                                            position: relative;
                                            width: 100%;
                                            height: 0;
                                            padding: 0;
                                            padding-bottom: 141.4516129032258%;
                                            margin-bottom: 50px;
                                        "
                                    >
                                        <svg
                                            id="svg-document-validation"
                                            v-if="document"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="100%"
                                            :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                            style="
                                                position: absolute;
                                                width: 100%;
                                                left: 0;
                                                top: 0;
                                                background: #fff;
                                            "
                                        >
                                            <image
                                                id="svg-image-document-validation"
                                                :xlink:href="document.signedUrl"
                                                x="0"
                                                y="0"
                                                :height="`${imageHeight}px`"
                                                :width="`${imageWidth}px`"
                                            />
                                        </svg>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";

import UPDATE_DOCUMENT_EDIT from "../../graphql/document/UpdateDocumentEdit.gql";
import UPDATE_DOCUMENT_TYPE from "../../graphql/document/UpdateDocumentType.gql";

import Chat from "../chat/Chat.vue";
import { DocumentBase } from "./DocumentBase";
import { DocumentMenu } from "./DocumentMenu.vue";
import FreeTag from "../tag/FreeTag.vue";
import AccountableAccountVue from "../AccountableAccount.vue";
// import DocumentAccountableAccountsSelector from "./DocumentAccountableAccountsSelector.vue";
import ossPdf from "./DocumentPDF.vue";
import UploadDocuments from "./UploadDocuments.vue";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getSiretValue } from "../../../src/services/companyServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import {
    MenuDisplayOptions,
    MenuDisplayZoomOptions,
    MenuDisplayRotationOptions,
    MenuDisplayDownloadOptions,
    MenuDisplayDotMenuOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

@Component({
    components: {
        Chat,
        FreeTag,
        AccountableAccountVue,
        // DocumentAccountableAccountsSelector,
        ossPdf,
        UploadDocuments,
        DocumentMenu,
    },
    emits: ["edit"],
})
export class DocumentToReupload extends DocumentBase {
    step: number = 0;

    get showDocument() {
        return !!this.step;
    }

    set showDocument(value) {
        this.step = value ? 1 : 0;
    }

    get documentMenuOptionsZoomButton(): MenuDisplayZoomOptions {
        let zoomButton: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomButton.isDisplay = this.showZoomActions;
        zoomButton.isZoomInDisabled = this.zoomManager.disableZoomIn();
        zoomButton.isResetZoomDisabled = this.zoomManager.disableResetZoom();
        zoomButton.isZoomOutDisabled = this.zoomManager.disableZoomOut();

        return zoomButton;
    }
    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        let rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };

        rotationButton.isDisplay = this.showRotateActions;

        return rotationButton;
    }

    get documentMenuOptionsDownloadButton(): MenuDisplayDownloadOptions {
        let downloadButton: MenuDisplayDownloadOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.downloadButton,
        };

        downloadButton.isDisplay = true;

        return downloadButton;
    }

    get documentMenuOptionsDotMenu(): MenuDisplayDotMenuOptions {
        let dotMenu: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenu.isDisplay = true;

        dotMenu.delete.isDisplay = true;
        dotMenu.delete.title = "Supprimer";
        dotMenu.delete.disabled = this.disabledDelete;

        return dotMenu;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        let documentMenuOption: MenuDisplayOptions = { ...documentMenuDisplayOptionsDefaultScheme };

        documentMenuOption.zoomButtons = this.documentMenuOptionsZoomButton;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.downloadButton = this.documentMenuOptionsDownloadButton;
        documentMenuOption.dotMenu = this.documentMenuOptionsDotMenu;

        return documentMenuOption;
    }

    get headers() {
        if (this.multiAccountableAccount) {
            return [
                {
                    title: "Compte comptable",
                    value: "accountableAccount",
                    sortable: true,
                    align: "center",
                },
                { title: "HT", value: "netAmount", sortable: false, align: "center" },
                { title: "Taux", value: "vatRate", sortable: false, align: "center" },
                { title: "TVA", value: "vatAmount", sortable: false, align: "center" },
                { title: "TTC", value: "grossAmount", sortable: true, align: "center" },
            ];
        }
        return [
            { title: "HT", value: "netAmount", sortable: false, align: "center" },
            { title: "Taux", value: "vatRate", sortable: false, align: "center" },
            { title: "TVA", value: "vatAmount", sortable: false, align: "center" },
            { title: "TTC", value: "grossAmount", sortable: true, align: "center" },
        ];
    }

    valid = false;

    validated = false;

    loading = false;

    updating = false;

    dialogSelectCompany = false;

    windowStep = 0;

    showAccountingLines = false;

    // @State2Way("updateFilter", "documentFilter")
    // filter!: any;

    // @State2Way(
    //     "updateShowFilterBox",
    //     state => state.documentFilter.showFilterBox
    // )
    // showFilterBox!: boolean;

    // @State2Way("updatePagination", "documentFilter.pagination")
    // pagination!: any;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get fullAddress() {
        let address = "";
        if (!this.document || !this.document.thirdPartyCompany) {
            return address;
        }
        if (this.document.thirdPartyCompany.address) {
            address += this.document.thirdPartyCompany.address;
        }
        if (this.document.thirdPartyCompany.postalCode) {
            if (address) address += " ";
            address += this.document.thirdPartyCompany.postalCode;
        }
        return address;
    }

    getAmountClass(price) {
        let amountClass = "d-flex justify-center ";
        amountClass += price.total ? "font-weight-bold" : "font-weight-regular";
        return amountClass;
    }

    buildMetadata(document: any, key: string, valueType = "number") {
        return document[`${key}`];
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        await this.onDocumentChangedCommon(prev, next);
        if (prev !== next) {
            this.dueDate = this.inDocument.dueDate || this.inDocument.date;
        }
        this.finishMounted();
    }

    beforeMount() {
        this.svgSuffix = "document-to-reupload";
        debugger;
        this.onDocumentChanged(this.inDocument.id, undefined);
    }

    updateForm(document: any) {
        this.document = document;
        // console.log("heheheh", document.signedUrl);
        this.computeSVGVariants(document);
        // this.loadSubNetAmounts(document)
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "type";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }
    //
    // edit
    //

    editDialog = false;
    editLoading = false;

    get isEditable() {
        if (!this.inDocument.signedUrl) return false;
        // if (this.inDocument.importId) return false
        if (this.inDocument.accountingItemImport) return false;
        if (this.inDocument.invoice) return false;
        if (!this.analysis) return false;
        // if (this.inDocument.isDocOfZTillReceipt) return false
        // if (this.inDocument.vatDeclaration) return false
        // if (this.inDocument.isVatDocumentOf) return false

        if (
            this.inDocument.type !== "PURCHASE_INVOICE" &&
            this.inDocument.type !== "SALES_INVOICE" &&
            this.inDocument.type !== "EXPENSE_REPORT_DOCUMENT" &&
            this.inDocument.type !== "CURRENT_ACCOUNT" &&
            this.inDocument.type !== "OPERATOR_ACCOUNT"
        ) {
            return false;
        }
        return true;
    }

    async editDocument() {
        this.editLoading = true;
        if (this.document && this.document.id) {
            await this.$apollo.mutate({
                mutation: UPDATE_DOCUMENT_EDIT,
                variables: {
                    id: this.document.id,
                    status: "ANALYSED",
                },
            });
        }
        this.$emit("edit", {
            documentId: this.documentId,
        });
        this.editDialog = false;
        this.editLoading = false;
    }
    //
    // accountable account
    //

    subNetAmountsLoading = false;

    // activateSubNetAmountsStep() {
    // DEPRECATED
    // this.loadSubNetAmounts(this.document)
    // this.windowStep = 1;
    // }

    async switchToDocumentValidation() {
        await this.validMiscellaneous();
        await this.editDocument();
        this.startToBeDoneIfNecessary();
    }

    async validMiscellaneous() {
        debugger;
        await this.$apollo.mutate({
            mutation: UPDATE_DOCUMENT_TYPE,
            variables: {
                id: this.document.id,
                type: this.document.type,
                owner: this.currentAccountUser.id
                    ? { connect: { id: this.currentAccountUser.id } }
                    : undefined,
                status: "ANALYSED",
            },
        });
        if (this.document.type !== "MISCELLANEOUS" && this.document.type !== "BANK_STATEMENT") {
            this.analyseDocument();
        }
        this.startToBeDoneIfNecessary();
    }

    closeMultiAccountableAccountWindow() {
        this.subNetAmountsLoading = true;
        this._closeMultiAccountableAccountWindow();
        this.subNetAmountsLoading = false;
        this.windowStep = 0;
    }

    async onSubAccountableAccountModified() {
        this.subNetAmountsLoading = true;
        await this._onSubAccountableAccountModified();
        this.subNetAmountsLoading = false;
        this.windowStep = 0;
    }

    get multiAccountableAccount() {
        if (
            this.document.data &&
            this.document.data.subAmounts &&
            this.document.data.subAmounts.length
        ) {
            let aa;
            for (const subAmountData of this.document.data.subAmounts) {
                if (!subAmountData.accountableAccount) {
                    continue;
                }
                if (!aa) {
                    aa = subAmountData.accountableAccount;
                    continue;
                }
                if (aa !== subAmountData.accountableAccount) {
                    return true;
                }
            }
        }
        return false;
    }

    //
    // old version : subNetAmounts or netAmountSigned1 | netAmountSigned2 | netAmountSigned3
    //
    get oldVersion() {
        if (
            this.document.data &&
            this.document.data.subNetAmounts &&
            this.document.data.subNetAmounts.length
        ) {
            return true;
        }
        if (this.document.netAmount1) {
            return true;
        }
        return false;
    }

    get newVersion() {
        return !this.oldVersion;
    }

    get prices() {
        const prices = [];

        const signed = this.document.grossAmountSigned < 0 ? -1 : 1;
        //--------------------------------------
        // DEPRECATED : waiting full migration -
        // retro compatibilité
        //--------------------------------------
        if (this.document.netAmount1) {
            prices.push({
                total: false,
                netAmountSigned: -signed * this.document.netAmount1,
                vatAmountSigned: -signed * this.document.vatAmount1,
                grossAmountSigned: signed * this.document.grossAmount1,
                vatRate: this.document.vatRate1,
            });
        }
        if (this.document.netAmount2) {
            prices.push({
                total: false,
                netAmountSigned: -signed * this.document.netAmount2,
                vatAmountSigned: -signed * this.document.vatAmount2,
                grossAmountSigned: signed * this.document.grossAmount2,
                vatRate: this.document.vatRate2,
            });
        }
        if (this.document.netAmount3) {
            prices.push({
                total: false,
                netAmountSigned: -signed * this.document.netAmount3,
                vatAmountSigned: -signed * this.document.vatAmount3,
                grossAmountSigned: signed * this.document.grossAmount3,
                vatRate: this.document.vatRate3,
            });
        }
        //--------------
        // NEW VERSION -
        //--------------
        if (this.document.data && this.document.data.subAmounts) {
            debugger;
            for (const subAmountData of this.document.data.subAmounts) {
                const grossAmountSigned =
                    subAmountData.grossAmountSigned ||
                    -(subAmountData.netAmountSigned + subAmountData.vatAmountSigned);
                prices.push({
                    total: false,
                    netAmountSigned: subAmountData.netAmountSigned,
                    vatAmountSigned: subAmountData.vatAmountSigned,
                    grossAmountSigned: grossAmountSigned,
                    vatRate: subAmountData.vatRate,
                    vatType: subAmountData.vatType,
                    accountableAccount: subAmountData.accountableAccount,
                });
            }
        }
        for (const price of prices) {
            if (price.vatRate === 0) {
                price.vatType = this.document.vatType;
            }
        }
        //--------
        // TOTAL -
        //--------
        prices.push({
            total: true,
            vatAmountSigned: this.document.vatAmountSigned,
            netAmountSigned: this.document.netAmountSigned,
            grossAmountSigned: this.document.grossAmountSigned,
            vatRate: this.document.vatRate,
            vatTye: this.document.vatType,
        });

        return prices;
    }

    async reuploaded() {
        await this.$apollo.mutate({
            mutation: gql`
                mutation setToReuploadDocument($documentId: ID!) {
                    updateDocument(where: { id: $documentId }, data: { status: UPLOADED }) {
                        id
                    }
                }
            `,
            variables: {
                documentId: this.document.id,
            },
        });
        this.document.status = "UPLOADED";
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }
}

export default toNative(DocumentToReupload);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
